'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useDataGridContextValues_unstable", {
    enumerable: true,
    get: function() {
        return useDataGridContextValues_unstable;
    }
});
const _useTableContextValues = require("../Table/useTableContextValues");
function useDataGridContextValues_unstable(state) {
    const tableContextValues = (0, _useTableContextValues.useTableContextValues_unstable)(state);
    const { tableState, focusMode, selectableRows, subtleSelection, selectionAppearance, resizableColumns, compositeRowTabsterAttribute } = state;
    return {
        ...tableContextValues,
        dataGrid: {
            ...tableState,
            focusMode,
            selectableRows,
            subtleSelection,
            selectionAppearance,
            resizableColumns,
            compositeRowTabsterAttribute
        }
    };
}
